const floatValue = (value) => parseFloat(Number(value).toFixed(3))
const mobileAppVersionMatcher = /(\d+).(\d+).(\d+)/

const dynamicFloatFields = (cls, field) => {
  Object.defineProperty(cls, field, {
    get () {
      return cls[`_${field}`]
    },
    set (value) {
      cls[`_${field}`] = floatValue(value)
      return cls[`_${field}`]
    }
  })
}

// build=(\d+) - regex for app_version

export class UserSettings {
  constructor ({
    idSettings = -1,
    dateTime = new Date().getTime(),
    audioLevelPref = null,
    leftHeadAnglePref = null,
    rightHeadAnglePref = null,
    perclosPref = null,
    calibratedHeadAngleYawPref = null,
    calibratedHeadAnglePitchPref = null,
    upHeadAnglePref = null,
    downHeadAnglePref = null,
    intervalBetweenDetectDangersBetween = null,
    periodInDetectDanger = null,
    settingPictureContrast = null,
    settingPictureBrightness = null,
    settingPictureSize = null,
    leftEyeOpennessPercentagePref = null,
    rightEyeOpennessPercentagePref = null,
    deviceUuid = null,
    userId = null,
    driverGender = null,
    driverExperience = null,
    settingAutoAdjust = null,
    settingCameraZoom = null,
    driverBdate = null,
    settingPlayBeepEvent = null,
    settingPlayBeepDangerEvent = null,
    settingLastOpenedNavigApp = null,
    isDetectDrowsiness = null,
    isDetectDistraction = null,
    appVersion = null,
    osVersion = null,
    device = null,
    yawnCount = null,
    yawnPeriodDetect = null,
    trainModeEnabled = null,
    asrSystemLanguages = null,
    ttsSystemLanguages = null,
    autoCalibrateSpeed = null,
    autoCalibrateFirstPeriod = null,
    autoCalibrateRefineInterval = null,
    autoCalibrateEnabled = null,
    driverStatisticsEnabled = null,
    driverStatisticsSyncWifi = null,
    screenBrightness = null,
    finishAppOnCloseNavig = null,
    isVibrate = null,
    intervalBetweenRecommendationsSec = null,
    travelTimeLastStopHours = null,
    headRotateAngleDrowsinessDetect = null,
    thresholdMouthOpenDetect = null,
    isDetectSeatBelt = null,
    periodDetectDrowsiness = null,
    minFramesDetectDrowsiness = null,
    minFramesDetectDistraction = null,
    beepEventDrowsiness = null,
    beepEventDistraction = null,
    beepEventBelt = null,
    beepDangerDrowsiness = null,
    beepDangerDistraction = null,
    beepDangerBelt = null,
    maxFramesDetectSabotage = null,
    minFramesDetectSabotage = null,
    beepEventSabotage = null,
    beepDangerSabotage = null,
    notificationDrowsinessInterval = null,
    notificationDistractionInterval = null,
    notificationBeltInterval = null,
    notificationSabotageInterval = null,
    notificationDrowsinessTts = null,
    notificationDistractionTts = null,
    notificationBeltTts = null,
    notificationSabotageTts = null,
    isDetectCameraSabotage = null,
    mirrorImage = null,
    periodDetectBelt = null,
    periodDetectSabotage = null,
    headTiltAngleDrowsinessDetect = null,
    mouthWidthRatioSmile = null,
    distractionIntervalSpeedStart = null,
    distractionIntervalSpeedEnd = null,
    showServiceMessages = null,
    notificationCellPhoneTts = null,
    notificationCellPhoneInterval = null,
    notificationEatingInterval = null,
    notificationEatingTts = null,
    notificationSmokingInterval = null,
    notificationSmokingTts = null,
    isDetectCellPhone = null,
    periodDetectCellPhone = null,
    confidenceDetectCellPhone = null,
    isDetectEating = null,
    periodDetectEating = null,
    confidenceDetectEating = null,
    isDetectSmoking = null,
    periodDetectSmoking = null,
    confidenceDetectSmoking = null,
    mouthWidthCalibrated = null,
    isDetectDistractionNoFace = null,
    distractionNoFaceIntervalSpeedStart = null,
    distractionNoFaceIntervalSpeedEnd = null,
    distractionNoFaceIntervalTimeDetectStart = null,
    distractionNoFaceIntervalTimeDetectEnd = null,
    ratioFramesDistractionNoFace = null,
    isDetectDistractionNoAttention = null,
    distractionNoAttentionIntervalSpeedStart = null,
    distractionNoAttentionIntervalSpeedEnd = null,
    distractionNoAttentionIntervalTimeDetectStart = null,
    distractionNoAttentionIntervalTimeDetectEnd = null,
    distractionNoAttentionLeftHeadAnglePref = null,
    distractionNoAttentionRightHeadAnglePref = null,
    distractionNoAttentionUpHeadAnglePref = null,
    distractionNoAttentionDownHeadAnglePref = null,
    ratioFramesDistractionNoAttention = null,
    timeDetectOneYawn = null,
    showDebugInfoVideo = null,
    isDetectBackBelt = null,
    confidenceDetectBackBeltTop = null,
    confidenceDetectBackBeltBottom = null,
    confidenceDetectFrontBeltTop = null,
    confidenceDetectFrontBeltBottom = null,
    detectorStopRepeatCount = null,
    detectorStopActivatePeriod = null,
    detectorStopSuspendTime = null,
    isDetectCameraCalibrate = null,
    yawnFramesRatioDetect = null,
    minSpeedDrowsiness = null,
    minSpeedDistractionNoFace = null,
    minSpeedDistractionNoAttention = null,
    minSpeedCameraSabotage = null,
    minSpeedBeltNotFasten = null,
    minSpeedCellPhone = null,
    minSpeedSmoking = null,
    minSpeedEating = null,
    beltModelFramesPerSecond = null,
    percentFramesDetectBelt = null,
    percentFramesDetectPhone = null,
    percentFramesDetectEating = null,
    percentFramesDetectSmoking = null,
    detectorLowLightThreshold = null,
    imageRotateAngle = null,
    notificationCameraOffTts = null,
    notificationCameraOffInterval = null,
    confidenceDetectGazeRadio = null,
    notificationDistractionNoAttentionTts = null,
    notificationDistractionNoAttentionInterval = null,
    notificationDistractionNoFaceTts = null,
    notificationDistractionNoFaceInterval = null,
    mirrorImageDriver = null,
    mirrorImageRoad = null
  } = {}) {
    this.idSettings = idSettings
    this.dateTime = new Date(dateTime)
    this.audioLevelPref = audioLevelPref
    this.leftHeadAnglePref = leftHeadAnglePref
    this.rightHeadAnglePref = rightHeadAnglePref
    this._perclosPref = floatValue(perclosPref)
    this.calibratedHeadAngleYawPref = calibratedHeadAngleYawPref
    this.calibratedHeadAnglePitchPref = calibratedHeadAnglePitchPref
    this.upHeadAnglePref = upHeadAnglePref
    this.downHeadAnglePref = downHeadAnglePref
    this.intervalBetweenDetectDangersBetween = intervalBetweenDetectDangersBetween
    this.periodInDetectDanger = periodInDetectDanger
    this.settingPictureContrast = settingPictureContrast
    this.settingPictureBrightness = settingPictureBrightness
    this.settingPictureSize = settingPictureSize
    this._leftEyeOpennessPercentagePref = floatValue(leftEyeOpennessPercentagePref)
    this._rightEyeOpennessPercentagePref = floatValue(rightEyeOpennessPercentagePref)
    this.deviceUuid = deviceUuid
    this.userId = userId
    this.driverGender = driverGender
    this.driverExperience = driverExperience
    this.settingAutoAdjust = settingAutoAdjust
    this.settingCameraZoom = settingCameraZoom
    this.driverBdate = driverBdate
    this.settingPlayBeepEvent = settingPlayBeepEvent
    this.settingPlayBeepDangerEvent = settingPlayBeepDangerEvent
    this.settingLastOpenedNavigApp = settingLastOpenedNavigApp
    this.isDetectDrowsiness = isDetectDrowsiness
    this.isDetectDistraction = isDetectDistraction

    try {
      this.appVersion = JSON.parse(appVersion)
    } catch (e) {
      this.appVersion = appVersion
    }

    this.osVersion = osVersion
    this.device = device
    this.yawnCount = yawnCount
    this.yawnPeriodDetect = yawnPeriodDetect
    this.trainModeEnabled = trainModeEnabled
    this.asrSystemLanguages = asrSystemLanguages
    this.ttsSystemLanguages = ttsSystemLanguages
    this.autoCalibrateSpeed = autoCalibrateSpeed
    this.autoCalibrateFirstPeriod = autoCalibrateFirstPeriod
    this.autoCalibrateRefineInterval = autoCalibrateRefineInterval
    this.autoCalibrateEnabled = autoCalibrateEnabled
    this.driverStatisticsEnabled = driverStatisticsEnabled
    this.driverStatisticsSyncWifi = driverStatisticsSyncWifi
    this.screenBrightness = screenBrightness
    this.finishAppOnCloseNavig = finishAppOnCloseNavig
    this.isVibrate = isVibrate
    this.intervalBetweenRecommendationsSec = intervalBetweenRecommendationsSec
    this.travelTimeLastStopHours = travelTimeLastStopHours
    this.headRotateAngleDrowsinessDetect = headRotateAngleDrowsinessDetect
    this._thresholdMouthOpenDetect = floatValue(thresholdMouthOpenDetect)
    this.isDetectSeatBelt = isDetectSeatBelt
    this.periodDetectDrowsiness = periodDetectDrowsiness
    this.minFramesDetectDrowsiness = minFramesDetectDrowsiness
    this.minFramesDetectDistraction = minFramesDetectDistraction
    this.beepEventDrowsiness = beepEventDrowsiness
    this.beepEventDistraction = beepEventDistraction
    this.beepEventBelt = beepEventBelt
    this.beepDangerDrowsiness = beepDangerDrowsiness
    this.beepDangerDistraction = beepDangerDistraction
    this.beepDangerBelt = beepDangerBelt
    this.maxFramesDetectSabotage = maxFramesDetectSabotage
    this.minFramesDetectSabotage = minFramesDetectSabotage
    this.beepEventSabotage = beepEventSabotage
    this.beepDangerSabotage = beepDangerSabotage
    this.notificationDrowsinessInterval = notificationDrowsinessInterval
    this.notificationDistractionInterval = notificationDistractionInterval
    this.notificationBeltInterval = notificationBeltInterval
    this.notificationSabotageInterval = notificationSabotageInterval
    this.notificationDrowsinessTts = notificationDrowsinessTts
    this.notificationDistractionTts = notificationDistractionTts
    this.notificationBeltTts = notificationBeltTts
    this.notificationSabotageTts = notificationSabotageTts
    this.isDetectCameraSabotage = isDetectCameraSabotage
    this.mirrorImage = mirrorImage
    this.periodDetectBelt = periodDetectBelt
    this.periodDetectSabotage = periodDetectSabotage
    this.headTiltAngleDrowsinessDetect = headTiltAngleDrowsinessDetect
    this._mouthWidthRatioSmile = floatValue(mouthWidthRatioSmile)
    this._distractionIntervalSpeedStart = floatValue(distractionIntervalSpeedStart)
    this._distractionIntervalSpeedEnd = floatValue(distractionIntervalSpeedEnd)
    this.showServiceMessages = showServiceMessages
    this.notificationCellPhoneTts = notificationCellPhoneTts
    this.notificationCellPhoneInterval = notificationCellPhoneInterval
    this.notificationEatingInterval = notificationEatingInterval
    this.notificationEatingTts = notificationEatingTts
    this.notificationSmokingInterval = notificationSmokingInterval
    this.notificationSmokingTts = notificationSmokingTts
    this.isDetectCellPhone = isDetectCellPhone
    this.periodDetectCellPhone = periodDetectCellPhone
    this._confidenceDetectCellPhone = floatValue(confidenceDetectCellPhone)
    this.isDetectEating = isDetectEating
    this.periodDetectEating = periodDetectEating
    this._confidenceDetectEating = floatValue(confidenceDetectEating)
    this.isDetectSmoking = isDetectSmoking
    this.periodDetectSmoking = periodDetectSmoking
    this._confidenceDetectSmoking = floatValue(confidenceDetectSmoking)
    this._mouthWidthCalibrated = floatValue(mouthWidthCalibrated)
    this.isDetectDistractionNoFace = isDetectDistractionNoFace
    this._distractionNoFaceIntervalSpeedStart = floatValue(distractionNoFaceIntervalSpeedStart)
    this._distractionNoFaceIntervalSpeedEnd = floatValue(distractionNoFaceIntervalSpeedEnd)
    this.distractionNoFaceIntervalTimeDetectStart = distractionNoFaceIntervalTimeDetectStart
    this.distractionNoFaceIntervalTimeDetectEnd = distractionNoFaceIntervalTimeDetectEnd
    this._ratioFramesDistractionNoFace = floatValue(ratioFramesDistractionNoFace)
    this.isDetectDistractionNoAttention = isDetectDistractionNoAttention
    this._distractionNoAttentionIntervalSpeedStart = floatValue(distractionNoAttentionIntervalSpeedStart)
    this._distractionNoAttentionIntervalSpeedEnd = floatValue(distractionNoAttentionIntervalSpeedEnd)
    this.distractionNoAttentionIntervalTimeDetectStart = distractionNoAttentionIntervalTimeDetectStart
    this.distractionNoAttentionIntervalTimeDetectEnd = distractionNoAttentionIntervalTimeDetectEnd
    this._distractionNoAttentionLeftHeadAnglePref = floatValue(distractionNoAttentionLeftHeadAnglePref)
    this._distractionNoAttentionRightHeadAnglePref = floatValue(distractionNoAttentionRightHeadAnglePref)
    this._distractionNoAttentionUpHeadAnglePref = floatValue(distractionNoAttentionUpHeadAnglePref)
    this._distractionNoAttentionDownHeadAnglePref = floatValue(distractionNoAttentionDownHeadAnglePref)
    this._ratioFramesDistractionNoAttention = floatValue(ratioFramesDistractionNoAttention)
    this.timeDetectOneYawn = timeDetectOneYawn
    this.showDebugInfoVideo = showDebugInfoVideo
    this.isDetectBackBelt = isDetectBackBelt
    this._confidenceDetectBackBeltTop = floatValue(confidenceDetectBackBeltTop)
    this._confidenceDetectBackBeltBottom = floatValue(confidenceDetectBackBeltBottom)
    this._confidenceDetectFrontBeltTop = floatValue(confidenceDetectFrontBeltTop)
    this._confidenceDetectFrontBeltBottom = floatValue(confidenceDetectFrontBeltBottom)
    this.detectorStopRepeatCount = detectorStopRepeatCount
    this.detectorStopActivatePeriod = detectorStopActivatePeriod
    this.detectorStopSuspendTime = detectorStopSuspendTime
    this.isDetectCameraCalibrate = isDetectCameraCalibrate
    this._yawnFramesRatioDetect = floatValue(yawnFramesRatioDetect)

    this._minSpeedDrowsiness = floatValue(minSpeedDrowsiness)
    this._minSpeedDistractionNoFace = floatValue(minSpeedDistractionNoFace)
    this._minSpeedDistractionNoAttention = floatValue(minSpeedDistractionNoAttention)
    this._minSpeedCameraSabotage = floatValue(minSpeedCameraSabotage)
    this._minSpeedBeltNotFasten = floatValue(minSpeedBeltNotFasten)
    this._minSpeedCellPhone = floatValue(minSpeedCellPhone)
    this._minSpeedSmoking = floatValue(minSpeedSmoking)
    this._minSpeedEating = floatValue(minSpeedEating)

    this._beltModelFramesPerSecond = floatValue(beltModelFramesPerSecond)
    this._percentFramesDetectBelt = floatValue(percentFramesDetectBelt)
    this._percentFramesDetectPhone = floatValue(percentFramesDetectPhone)
    this._percentFramesDetectEating = floatValue(percentFramesDetectEating)
    this._percentFramesDetectSmoking = floatValue(percentFramesDetectSmoking)

    this.detectorLowLightThreshold = detectorLowLightThreshold
    this.imageRotateAngle = imageRotateAngle

    this.notificationCameraOffTts = notificationCameraOffTts
    this.notificationCameraOffInterval = notificationCameraOffInterval

    this._confidenceDetectGazeRadio = floatValue(confidenceDetectGazeRadio)

    this.notificationDistractionNoAttentionTts = notificationDistractionNoAttentionTts
    this.notificationDistractionNoAttentionInterval = notificationDistractionNoAttentionInterval
    this.notificationDistractionNoFaceTts = notificationDistractionNoFaceTts
    this.notificationDistractionNoFaceInterval = notificationDistractionNoFaceInterval

    this.mirrorImageDriver = mirrorImageDriver
    this.mirrorImageRoad = mirrorImageRoad

    this._initDynamicFields()
  }

  _initDynamicFields () {
    [
      'perclosPref', 'mouthWidthRatioSmile', 'distractionIntervalSpeedStart', 'distractionIntervalSpeedEnd',
      'confidenceDetectCellPhone', 'confidenceDetectEating',
      'confidenceDetectSmoking', 'mouthWidthCalibrated', 'thresholdMouthOpenDetect', 'distractionNoFaceIntervalSpeedStart',
      'distractionNoFaceIntervalSpeedEnd', 'ratioFramesDistractionNoFace', 'distractionNoAttentionIntervalSpeedStart',
      'distractionNoAttentionIntervalSpeedEnd', 'distractionNoAttentionLeftHeadAnglePref', 'distractionNoAttentionRightHeadAnglePref',
      'distractionNoAttentionUpHeadAnglePref', 'distractionNoAttentionDownHeadAnglePref', 'ratioFramesDistractionNoAttention',
      'confidenceDetectBackBeltTop', 'confidenceDetectBackBeltBottom',
      'confidenceDetectFrontBeltTop', 'confidenceDetectFrontBeltBottom',
      'yawnFramesRatioDetect', 'minSpeedDrowsiness', 'minSpeedDistractionNoFace',
      'minSpeedDistractionNoAttention', 'minSpeedCameraSabotage', 'minSpeedBeltNotFasten',
      'minSpeedCellPhone', 'minSpeedSmoking', 'minSpeedEating', 'beltModelFramesPerSecond',
      'percentFramesDetectBelt', 'percentFramesDetectPhone', 'percentFramesDetectEating',
      'percentFramesDetectSmoking', 'confidenceDetectGazeRadio'
    ].forEach(field => dynamicFloatFields(this, field))
  }

  get defaults () {
    // TODO: fetch default settings from server
    return {
      leftHeadAnglePref: 20.0,
      rightHeadAnglePref: 20.0,
      perclosPref: 0.55,
      upHeadAnglePref: 15.0,
      downHeadAnglePref: 15.0,
      intervalBetweenDetectDangersBetween: 10000,
      periodInDetectDanger: 1500.0,
      settingPictureContrast: 1,
      settingPictureSize: 350,
      leftEyeOpennessPercentagePref: 0.2,
      rightEyeOpennessPercentagePref: 0.2,
      settingAutoAdjust: true,
      settingCameraZoom: 0.0,
      settingPlayBeepEvent: false,
      settingPlayBeepDangerEvent: true,
      isDetectDrowsiness: true,
      isDetectDistraction: true,
      yawnCount: 2,
      yawnPeriodDetect: 600,
      trainModeEnabled: false,
      autoCalibrateSpeed: 30.0,
      autoCalibrateFirstPeriod: 30,
      autoCalibrateRefineInterval: 5,
      autoCalibrateEnabled: true,
      driverStatisticsEnabled: true,
      driverStatisticsSyncWifi: false,
      screenBrightness: -1,
      finishAppOnCloseNavig: false,
      isVibrate: true,
      intervalBetweenRecommendationsSec: 300,
      travelTimeLastStopHours: 0.5,
      headRotateAngleDrowsinessDetect: 10.0,
      thresholdMouthOpenDetect: 0.55,
      isDetectSeatBelt: true,
      periodDetectDrowsiness: 1500,
      minFramesDetectDrowsiness: 5,
      minFramesDetectDistraction: 5,
      beepEventDrowsiness: false,
      beepEventDistraction: false,
      beepEventBelt: false,
      beepDangerDrowsiness: true,
      beepDangerDistraction: true,
      beepDangerBelt: true,
      maxFramesDetectSabotage: 16,
      minFramesDetectSabotage: 5,
      beepEventSabotage: false,
      beepDangerSabotage: true,
      notificationDrowsinessInterval: 10,
      notificationDistractionInterval: 10,
      notificationBeltInterval: 10,
      notificationSabotageInterval: 10,
      notificationDrowsinessTts: true,
      notificationDistractionTts: true,
      notificationBeltTts: true,
      notificationSabotageTts: true,
      isDetectCameraSabotage: true,
      mirrorImage: false,
      periodDetectBelt: 1500,
      periodDetectSabotage: 1500,
      headTiltAngleDrowsinessDetect: 10.0,
      mouthWidthRatioSmile: 0.1,
      distractionIntervalSpeedStart: 15.0,
      distractionIntervalSpeedEnd: 80,
      showServiceMessages: true,
      notificationCellPhoneTts: true,
      notificationCellPhoneInterval: 10,
      notificationEatingInterval: 10,
      notificationEatingTts: true,
      notificationSmokingInterval: 10,
      notificationSmokingTts: true,
      isDetectCellPhone: true,
      periodDetectCellPhone: 1500,
      confidenceDetectCellPhone: 0.2,
      isDetectEating: true,
      periodDetectEating: 1500,
      confidenceDetectEating: 0.2,
      isDetectSmoking: true,
      periodDetectSmoking: 1500,
      confidenceDetectSmoking: 0.2,
      mouthWidthCalibrated: 0.0,
      isDetectDistractionNoFace: true,
      distractionNoFaceIntervalSpeedStart: 15.0,
      distractionNoFaceIntervalSpeedEnd: 80.0,
      distractionNoFaceIntervalTimeDetectStart: 4000,
      distractionNoFaceIntervalTimeDetectEnd: 1000,
      ratioFramesDistractionNoFace: 0.9,
      isDetectDistractionNoAttention: true,
      distractionNoAttentionIntervalSpeedStart: 15.0,
      distractionNoAttentionIntervalSpeedEnd: 80.0,
      distractionNoAttentionIntervalTimeDetectStart: 4000,
      distractionNoAttentionIntervalTimeDetectEnd: 1000,
      distractionNoAttentionLeftHeadAnglePref: 20,
      distractionNoAttentionRightHeadAnglePref: 20,
      distractionNoAttentionUpHeadAnglePref: 15,
      distractionNoAttentionDownHeadAnglePref: 15,
      ratioFramesDistractionNoAttention: 0.75,
      timeDetectOneYawn: 1500,
      showDebugInfoVideo: false,
      isDetectBackBelt: true,
      confidenceDetectBackBeltTop: 0.5,
      confidenceDetectBackBeltBottom: 0.5,
      confidenceDetectFrontBeltTop: 0.5,
      confidenceDetectFrontBeltBottom: 0.5,
      detectorStopRepeatCount: 3,
      detectorStopActivatePeriod: 15,
      detectorStopSuspendTime: 120,
      isDetectCameraCalibrate: false,
      yawnFramesRatioDetect: 0.75,
      beltModelFramesPerSecond: 4.0,
      percentFramesDetectBelt: 0.75,
      percentFramesDetectPhone: 0.75,
      percentFramesDetectEating: 0.75,
      percentFramesDetectSmoking: 0.75,
      detectorLowLightThreshold: 0,
      imageRotateAngle: 0,
      notificationCameraOffTts: true,
      notificationCameraOffInterval: 10,
      confidenceDetectGazeRadio: 0.5
    }
  }

  get buildVersion () {
    if (!this.appVersion) {
      return null
    }

    if (typeof this.appVersion === 'object') {
      return this.appVersion.build
    } else {
      const matchers = this.appVersion.match(/build='?(\d+)'?/)

      if (matchers && matchers.length > 1) {
        return matchers[1]
      } else {
        const matchers = this.appVersion.match(mobileAppVersionMatcher)
        if (matchers && matchers.length > 1) {
          return this.appVersion
        }
      }
    }
  }

  get distractionSplitted () {
    const build = this.buildVersion
    if (!build) {
      return false
    } else {
      const matchers = build.match(mobileAppVersionMatcher)
      if (matchers && matchers.length > 1) {
        const result = matchers[2].localeCompare('3')
        return result >= 0
      } else {
        const buildFormatted = Number(build)
        return buildFormatted >= 1085
      }
    }
  }

  isExisted () {
    return this.idSettings !== -1
  }

  backendModel () {
    const result = {}

    Object.keys(this).forEach(key => {
      // check if result is '' -> replace as null
      if (this[key] === '') {
        result[key] = null
      }
      if (this[key] instanceof Date) {
        result[key] = this[key].getTime()
      } else if (key === 'appVersion' && typeof this[key] === 'object') {
        result[key] = JSON.stringify(this[key])
      } else {
        result[key.replace('_', '')] = this[key]
      }
    })

    return result
  }

  get excludedFields () {
    return ['idSettings', 'dateTime', 'userId', 'deviceUuid', 'driverGender', 'driverExperience', 'driverBdate', 'settingLastOpenedNavigApp',
      'appVersion', 'osVersion', 'device', 'asrSystemLanguages', 'ttsSystemLanguages']
  }

  get leftEyeOpennessPercentagePref () {
    return this._leftEyeOpennessPercentagePref * 100
  }

  set leftEyeOpennessPercentagePref (value) {
    this._leftEyeOpennessPercentagePref = value / 100
  }

  get rightEyeOpennessPercentagePref () {
    return this._rightEyeOpennessPercentagePref * 100
  }

  set rightEyeOpennessPercentagePref (value) {
    this._rightEyeOpennessPercentagePref = value / 100
  }
}
